import React, { useState, useEffect } from 'react';
import { MessageCircle, X } from 'lucide-react';
import { Button } from './ui/button';
import { companyInfo } from '../mockData';

const FloatingWhatsApp = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    // Show tooltip after 3 seconds
    const timer = setTimeout(() => {
      setShowTooltip(true);
    }, 3000);

    // Hide tooltip after 8 seconds
    const hideTimer = setTimeout(() => {
      setShowTooltip(false);
    }, 8000);

    return () => {
      clearTimeout(timer);
      clearTimeout(hideTimer);
    };
  }, []);

  const handleWhatsAppClick = () => {
    // Facebook Pixel - Track Contact event
    if (typeof window.fbq !== 'undefined') {
      window.fbq('track', 'Contact', {
        content_name: 'Floating WhatsApp Click',
        content_category: 'WhatsApp'
      });
    }
    const message = encodeURIComponent(
      'Assalamualaikum, saya ingin mendapatkan maklumat lanjut mengenai perkhidmatan kewangan anda.'
    );
    window.open(`https://wa.me/${companyInfo.whatsappNumber}?text=${message}`, '_blank');
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-24 right-6 z-50 hidden lg:flex items-end gap-3">
      {/* Tooltip */}
      {showTooltip && (
        <div className="bg-white shadow-2xl rounded-lg p-4 max-w-xs animate-fade-in border-2 border-emerald-200 relative">
          <button
            onClick={() => setShowTooltip(false)}
            className="absolute top-2 right-2 text-emerald-600 hover:text-emerald-800"
          >
            <X className="h-4 w-4" />
          </button>
          <p className="text-emerald-900 font-semibold mb-1">Ada pertanyaan?</p>
          <p className="text-emerald-700 text-sm">Chat dengan kami sekarang untuk maklumat lanjut!</p>
        </div>
      )}

      {/* WhatsApp Button */}
      <Button
        onClick={handleWhatsAppClick}
        className="bg-green-500 hover:bg-green-600 text-white rounded-full p-6 shadow-2xl hover:shadow-green-500/50 hover:scale-110 transition-all duration-300 animate-pulse-slow"
        size="lg"
      >
        <MessageCircle className="h-8 w-8" />
      </Button>
    </div>
  );
};

export default FloatingWhatsApp;